<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-房产-修改
    -->
    <el-dialog
    title="修改房产"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="70%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="120px">
      <div class="common-form">修改房产</div>

      <!-- 新增字段：所属物业 -->
      <el-form-item label="所属物业" prop="supply_id">
        <el-select v-model="form.supply_id" placeholder="请选择所属物业" class="max-w460">
          <el-option 
            v-for="item in supplyList" 
            :key="item.supply_id" 
            :label="item.name" 
            :value="item.supply_id">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="房产名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入房产名称" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="详细信息" >
        <el-button size="small" type="primary" @click="addOrder" >新增</el-button>
        <el-table :data="info"  border size="mini" style="width: 100%;margin-top: 20px;">



        <el-table-column prop="name" label="楼层"   >
            <template v-slot="scope">
                <div>
                  <div class="d-s-c">
                    <el-input style="width: 650px;" type="text" v-model="scope.row.floor"  placeholder="请输入楼层"></el-input>
                 
                  </div>
                </div>
              </template>
        </el-table-column>     


            
       <el-table-column prop="name" label="房号" >
              <template v-slot="scope">
                <div>
                  <div class="d-s-c">
                    <el-input style="width: 650px;" type="textarea" v-model="scope.row.room"  placeholder="请输入房号（多个房号用英文,隔开）"></el-input>
                 
                  </div>
                </div>
              </template>
        </el-table-column>    
        
        
        <el-table-column prop="name" label="选择维修人员" >
              <template v-slot="scope">
                <div class="d-s-s d-c">
          <el-button @click="openWeixiu(scope.$index)" icon="el-icon-plus">选择维修人员</el-button>
          <ul class="d-s-s select-user" >
             <li 
          v-if="item.user_id" 
          v-for="(item,index) in scope.row.repair_staff" 
          :key="item.user_id" 
          class="mr10 d-c-c d-c p-10-0 relative"  
        >
              <img :src="item.avatarUrl" class="radius" width="30" height="30" />
              <p class="lh18 ww100 text-ellipsis">{{item.nickName}}</p>
              <i 
                class="el-icon-close delete-staff-icon" 
                @click.stop="deleteStaff(scope.$index, index)" 
              ></i>
            </li>
          </ul>
        </div>
              </template>
        </el-table-column>     




  
       <el-table-column prop="name" label="操作"  width="100">
              <template v-slot="scope">
                <div style="color: blue;" @click="delOrder(scope.$index)">删除</div>

              </template>
            </el-table-column>
          </el-table>
      </el-form-item> 
     
      <!-- <el-form-item label="楼层" prop="floor_numbers">
        <el-input 
          v-model="form.floor_numbers" 
          placeholder="请输入楼层，多个楼层用逗号分隔，例如：1,2" 
          class="max-w460">
        </el-input>
        <div class="tip-text">多个楼层请用逗号分隔</div>
      </el-form-item> -->
      <!-- 新增字段：房号（可填写多个） -->
      <!-- <el-form-item label="房号" prop="room_numbers">
        <el-input 
          v-model="form.room_numbers" 
          placeholder="请输入房号，多个房号用逗号分隔，例如：01,02" 
          class="max-w460">
        </el-input>
        <div class="tip-text">多个房号请用逗号分隔</div>
      </el-form-item> -->

      <!-- 新增字段：预期通知天数 -->
      <el-form-item label="预期通知天数" prop="notice_days">
        <el-input-number 
          v-model="form.notice_days" 
          :min="0" 
          :max="30" 
          placeholder="请输入预期通知天数"
          class="max-w200">
        </el-input-number>
        <span class="tip-text">天（逾期前多少天通知）</span>
      </el-form-item>

      <!-- 状态选择 -->
      <el-form-item label="状态" prop="status">
        <el-radio-group v-model="form.status">
          <el-radio :label="1">常住</el-radio>
          <el-radio :label="2">空置</el-radio>
        </el-radio-group>
      </el-form-item>

      <!-- 选择管家 -->
      <el-form-item label="管家" :rules="[{required: true,message: '请选择管家'}]">
        <div class="d-s-s d-c">
          <el-button @click="openStaff" icon="el-icon-plus">选择管家</el-button>
          <ul class="d-s-s select-user">
            <li v-if="staff.staff_id" class="mr10 d-c-c d-c p-10-0">
              <img :src="staff.image_url" class="radius" width="30" height="30" />
              <p class="lh18 ww100 text-ellipsis">{{staff.name}}</p>
            </li>
          </ul>
        </div>
      </el-form-item>

      <!-- 费用信息 -->
      <!-- <el-form-item label="基础费用/月">
        <div class="fee-container">
          <el-form-item label="物业费用" prop="property_fee" class="fee-item">
            <el-input v-model="form.property_fee" placeholder="请输入物业费用" class="max-w200">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <el-form-item label="水费" prop="water_fee" class="fee-item">
            <el-input v-model="form.water_fee" placeholder="请输入水费" class="max-w200">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <el-form-item label="电费" prop="electric_fee" class="fee-item">
            <el-input v-model="form.electric_fee" placeholder="请输入电费" class="max-w200">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <el-form-item label="车位费" prop="parking_fee" class="fee-item">
            <el-input v-model="form.parking_fee" placeholder="请输入车位费" class="max-w200">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
        </div>
      </el-form-item> -->

      <!-- 违约金信息 -->
      <!-- <el-form-item label="违约金/天">
        <div class="fee-container">
          <el-form-item label="物业违约金" prop="property_penalty" class="fee-item">
            <el-input v-model="form.property_penalty" placeholder="物业违约金" class="max-w200">
              <template slot="append">元/天</template>
            </el-input>
          </el-form-item>
          <el-form-item label="水费违约金" prop="water_penalty" class="fee-item">
            <el-input v-model="form.water_penalty" placeholder="水费违约金" class="max-w200">
              <template slot="append">元/天</template>
            </el-input>
          </el-form-item>
          <el-form-item label="电费违约金" prop="electric_penalty" class="fee-item">
            <el-input v-model="form.electric_penalty" placeholder="电费违约金" class="max-w200">
              <template slot="append">元/天</template>
            </el-input>
          </el-form-item>
          <el-form-item label="车位费违约金" prop="parking_penalty" class="fee-item">
            <el-input v-model="form.parking_penalty" placeholder="车位费违约金" class="max-w200">
              <template slot="append">元/天</template>
            </el-input>
          </el-form-item>
        </div>
      </el-form-item> -->

      <el-form-item label="房产bannar：" prop="bannar">
        <div class="draggable-list">
          <draggable class="wrapper" v-model="form.bannar">
            <transition-group>
              <div v-for="(item, index) in form.bannar" :key="item.file_path">
                <div class="item">
                  <img v-img-url="item.file_path" alt="file_path"/>
                  <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'bannar')"><i class="el-icon-close"></i></a>
                </div>
              </div>
            </transition-group>
          </draggable>
          <div class="item img-select" @click="openProductUpload('bannar')">
            <i class="el-icon-plus"></i>
          </div>
        </div>
      </el-form-item>

      <el-form-item label="房产图片：" prop="image">
        <div class="draggable-list">
          <draggable class="wrapper" v-model="form.image">
            <transition-group>
              <div v-for="(item, index) in form.image" :key="item.file_path">
                <div class="item">
                  <img v-img-url="item.file_path" alt="file_path"/>
                  <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'album')"><i class="el-icon-close"></i></a>
                </div>
              </div>
            </transition-group>
          </draggable>
          <div class="item img-select" @click="openProductUpload('album')">
            <i class="el-icon-plus"></i>
          </div>
        </div>
      </el-form-item>

      <el-form-item label="房产介绍">
        <div class="edit_container">
          <Uediter v-model="form.intro" :text="ueditor.text" :config="ueditor.config" ref="ue"></Uediter>
        </div>
      </el-form-item>  

      <el-form-item label="排序" prop="sort">
        <el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input>
      </el-form-item>
       
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
    
    <!-- 选择管家组件 -->
    <Staff :storeId="Number(form.staff_id)" :is_open="isOpenStaff"
          :supply_id="form.supply_id"
          :multi="false" @close="closeStaffFunc"></Staff>
          <Weixiu :storeId="Number(form.user_id)" :is_open="isopenWeixiu"
    :user_id="form.user_id"
          :multi="true" @close="closeWeixiuFunc"></Weixiu>
  </div>
</el-dialog>
</template>

<script>
import Real_estateApi from '@/api/real_estate.js';
import SupplyApi from '@/api/supply.js'; // 引入物业API
import Upload from '@/components/file/Upload';
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';
import Staff from '@/components/user/Staff.vue';
import Weixiu from '@/components/user/GetRepair.vue';

export default {
  components: {
     Upload,
     draggable,
     Uediter,
     Staff,
     Weixiu
  },
  data() {
    // 费用验证规则
    const validateFee = (rule, value, callback) => {
      if (value && isNaN(value)) {
        callback(new Error('请输入有效的数字'));
      } else if (value && value < 0) {
        callback(new Error('费用不能为负数'));
      } else {
        callback();
      }
    };
    
    return {
      /*是否上传图片*/
      isupload: false,
      isImg: false,  
      /*富文本配置*/
      ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      info:[],
      /*form表单数据*/
      form: {
        name: '',
        code: 'custom',
        image:[],
        sort:50,
        intro:"",
        bannar:[],
        status: 1, // 1:常住, 2:空置
        staff_id: 0,
        supply_id: '', // 所属物业ID
        // floor_numbers:'',
        // room_numbers: '', // 房号
        notice_days: 7, // 预期通知天数，默认7天
        property_fee: '',
        water_fee: '',
        electric_fee: '',
        parking_fee: '',
        property_penalty: '', // 物业违约金
        water_penalty: '', // 水费违约金
        electric_penalty: '', // 电费违约金
        parking_penalty: '' // 车位费违约金
      },
      // 物业列表
      supplyList: [],
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入房产名称', trigger: 'blur' }],
        supply_id: [{ required: true, message: '请选择所属物业', trigger: 'change' }],
        // floor_numbers: [{ required: true, message: '请输入楼层', trigger: 'blur' }],
        // room_numbers: [{ required: true, message: '请输入房号', trigger: 'blur' }],
        notice_days: [{ required: true, message: '请输入预期通知天数', trigger: 'blur' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }],
        property_fee: [{ validator: validateFee, trigger: 'blur' }],
        water_fee: [{ validator: validateFee, trigger: 'blur' }],
        electric_fee: [{ validator: validateFee, trigger: 'blur' }],
        parking_fee: [{ validator: validateFee, trigger: 'blur' }],
        property_penalty: [{ validator: validateFee, trigger: 'blur' }],
        water_penalty: [{ validator: validateFee, trigger: 'blur' }],
        electric_penalty: [{ validator: validateFee, trigger: 'blur' }],
        parking_penalty: [{ validator: validateFee, trigger: 'blur' }]
      },
      dialogVisible:false,
      isProductUpload:false,
      code:"album",
      // 选择用户开关
      isOpenStaff: false,
      staff: {},
      currentWeixiuRow:-1,
      isopenWeixiu:false,
      weixiu:[ {
        id: '', 
        floor: '',
        room: '', 
        repair_staff: [] 
      }]
    };
  },
  created() {
    this.dialogVisible = this.open_add;
    this.getSupplyList(); // 获取物业列表
    this.getDetail();
  },
  props: ["open_add","real_estate_id"],
  methods: {
    deleteStaff(rowIndex, staffIndex) {
        const repairStaffList = this.info[rowIndex].repair_staff;
        repairStaffList.splice(staffIndex, 1);
        this.info[rowIndex].repair_staff = [...repairStaffList];
        
    },
     openWeixiu(rowIndex) {
      this.isopenWeixiu = true;
      this.currentWeixiuRow = rowIndex;
    },
    
    /*关闭获取用户*/
    closeWeixiuFunc(e) {
        if (e.type != 'error') {
          // 1. 获取当前行的原有维修人员数组（若为空则初始化为空数组）
          const currentStaffList = this.info[this.currentWeixiuRow].repair_staff || [];
          
          // 2. 获取新选择的维修人员数组（e.params）
          const newStaffList = e.params || [];
          
          // 3. 合并数组并去重（基于 user_id 避免重复）
          // - 先创建一个 Set 存储已有的 user_id，用于快速去重
          const existingUserIds = new Set(currentStaffList.map(staff => staff.user_id));
          
          // - 过滤新选择的人员：只保留原有数组中没有的人员
          const filteredNewStaff = newStaffList.filter(staff => {
            // 确保 staff 有 user_id（避免异常数据）
            if (!staff.user_id) return false;
            // 若 user_id 不在 existingUserIds 中，则保留
            return !existingUserIds.has(staff.user_id);
          });
          
          // 4. 追加到原有数组（合并原有数组 + 过滤后的新人员）
          const mergedStaffList = [...currentStaffList, ...filteredNewStaff];
          
          // 5. 赋值回当前行的 repair_staff 字段
          this.info[this.currentWeixiuRow].repair_staff = mergedStaffList;
        }
        this.isopenWeixiu = false;
    },
    addOrder(){
      this.info.push({
        // "code":this.randomString(8) || Date.now().toString(),
        "sort":50,
        "name":"",
        "repair_staff": [],
        "floor":'',
        "room":''
      });
    },
    delOrder(index){
        this.info.splice(index,1)
    },
    /*获取物业列表*/
    getSupplyList() {
      let self = this;
      SupplyApi.supplyList({}, true)
        .then(data => {
          self.supplyList = data.data.list.data || [];
        })
        .catch(error => {
          console.error('获取物业列表失败:', error);
        });
    },
    
    /*打开获取用户*/
    openStaff() {
      this.isOpenStaff = true;
    },
    
    /*关闭获取用户*/
    closeStaffFunc(e) {
      if (e.type != 'error') {
        this.form.staff_id = e.params.staff_id;
        this.staff = e.params;
      }
      this.isOpenStaff = false;
    },

    /*关闭弹窗*/
    dialogFormVisible(result) {
      this.$emit("close", {});
    },
    
    cancelFunc() {
      this.dialogFormVisible("error");
    },
    
    getDetail() {
      let self = this;
      Real_estateApi.detail({real_estate_id: self.real_estate_id},true).then(res => {
          self.form = res.data;
          self.ueditor.text = self.form.intro;
          self.isImg = true;
          
          // 初始化新增字段的数据
          if (!self.form.bannar) {
            self.form.bannar = [];
          }
          if (!self.form.image) {
            self.form.image = [];
          }
          if (!self.form.status) {
            self.form.status = 1; // 默认状态为常住
          }
          
          // 如果已有管家信息，初始化管家显示
          if (self.form.staff_id && self.form.staff_name) {
            self.staff = {
              staff_id: self.form.staff_id,
              name: self.form.staff_name,
              image_url: self.form.staff_image || ''
            };
          }
          
          // 初始化新增字段的默认值
          if (self.form.notice_days === undefined || self.form.notice_days === null) {
            self.form.notice_days = 7;
          }

          if (res.data.details && res.data.details.length > 0) {
          // 假设后端返回的详细信息在 res.data.details 中，字段与前端对齐
          self.info = res.data.details.map(item => ({
            // code: item.code || Date.now().toString(),
            sort: item.sort || 50,
            floor: item.floor || '', // 后端楼层字段
            room: item.room || '', // 后端房号字段
            repair_staff: item.repair_staff || [] // 后端维修人员数组，直接赋值
          }));
        } else {
          // 无数据时初始化一行空数据
          self.info = [{
            // code: Date.now().toString(),
            sort: 50,
            floor: '',
            room: '',
            repair_staff: []
          }];
        }



        })
        .catch(error => {});
    },
    
    onSubmit() {
      let self = this;
      let form = self.form;
      
      if(form.image.length <= 0){
        self.$message({
          message: "请上传图片",
          type: 'error'
        });
        return;
      }
      const invalidRow = self.info.find(row => !row.floor.trim() || !row.room.trim());
      if (invalidRow) {
        self.$message.error("所有详细信息行的“楼层”和“房号”不能为空");
        return;
      }
      const transformedDetails = self.info.map(row => {
        const filteredStaff = row.repair_staff.map(staff => ({
          user_id: staff.user_id || '',
          avatarUrl: staff.avatarUrl || '',
          nickName: staff.nickName || '未知人员'
        })).filter(staff => staff.user_id); // 过滤无效数据
        
        return {
          ...row,
          repair_staff: filteredStaff,
          sort: undefined,
          name: undefined
        };
      });

      form.details = transformedDetails;
      form.real_estate_id = self.real_estate_id;
      form.intro = this.$refs.ue.getUEContent();
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          Real_estateApi.edit(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error");
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*打开上传图片*/
    openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code;
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if(this.code == 'album'){
        if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          e.forEach((element) => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach((e) => {
              if (e === ext) {
                prevent = true;
                return false;
              }
            });
          });

          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }

          let imgs = this.form.image.concat(e);
          this.$set(this.form, "image", imgs);
        }
      } else {
        if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          e.forEach((element) => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach((e) => {
              if (e === ext) {
                prevent = true;
                return false;
              }
            });
          });

          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }

          let imgs = this.form.bannar.concat(e);
          this.$set(this.form, "bannar", imgs);
        }
      }
      
      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index, code) {
      if(code == 'album'){
        this.form.image.splice(index, 1);
      } else if(code == 'bannar'){
        this.form.bannar.splice(index, 1);
      }
    }
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}

/* 费用信息样式 */
.fee-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.fee-item {
  margin-bottom: 0;
}

.max-w200 {
  max-width: 200px;
}

.select-user {
  margin-top: 10px;
}

.select-user li {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 5px 10px;
  background-color: #f5f7fa;
}
.select-user li.relative {
  position: relative;
  /* 增加一点内边距，避免删除图标超出范围 */
  padding: 5px 10px 5px 5px;
}

/* 维修人员删除图标：绝对定位到右上角 */
.delete-staff-icon {
  position: absolute;
  top: -5px;    /* 向上偏移，贴近头像顶部 */
  right: -5px;  /* 向右偏移，贴近头像右侧 */
  width: 16px;  /* 图标大小 */
  height: 16px;
  line-height: 16px;
  text-align: center;
  background-color: #F56C6C;  /* 红色背景（警示色） */
  color: white;                /* 白色图标 */
  border-radius: 50%;          /* 圆形图标 */
  font-size: 12px;             /* 图标字体大小 */
  cursor: pointer;             /* 鼠标悬浮变指针 */
  opacity: 0.8;                /* 默认半透明 */
}

/* 鼠标悬浮时加深透明度，提升交互反馈 */
.delete-staff-icon:hover {
  opacity: 1;
}

</style>


// WEBPACK FOOTER //
// src/views/plus/real_estate/index/part/edit.vue